export const isNodeElement = (node?: unknown): node is Element => {
  return !!(
    node &&
    (node instanceof Element ||
      (node as Node).nodeType === 1 || // Thanks Brett! <3
      node === document)
  )
}

export const getNodeScope = (nodeScope?: unknown) => {
  return (
    nodeScope && isNodeElement(nodeScope)
      ? nodeScope
      : nodeScope === window
      ? window
      : document
  ) as Element
}

export const getClosestDocument = (node?: Element | string | null) => {
  return node && isNodeElement(node) ? node.ownerDocument : document
}

export function nodesHaveSameParent(
  parentSelector?: string,
  node1?: HTMLElement,
  node2?: HTMLElement
) {
  if (!parentSelector || !node1 || !node2) return false

  //for testing
  if (!node1.closest) {
    return false
  }

  const parent1 = node1.closest(parentSelector)
  const parent2 = node2.closest(parentSelector)

  if (!parent1 || !parent2) return false

  return parent1.isEqualNode(parent2)
}
